import CommunityMessagesAPI from '../api/CommunityMessageAPI';
import { store } from '../context/store';
import { IMentionedUser } from '../types/commentTypes';
import { ChatMediaType } from '../types/communityMessagesTypes';
import { DOC_FILE_TYPES } from './fileUtils';

export const mentionRegex = /{{[0-9a-f]{24}#[\s\S]*?}}/g;

export const isChannelLocked = (
  mangoArr: string[],
  badgeArr: string[],
): boolean => {
  const state = store.getState();
  const { type: userType } = state.user;
  const { userCommunityAccess } = state.community;
  const { subscribedMangoes } = state.mango;
  const hasRequiredBadge = badgeArr?.some((badgeId) =>
    userCommunityAccess?.accessBadges?.some((b) => b._id === badgeId),
  );

  const hasRequiredMango = mangoArr?.some((mangoId) =>
    subscribedMangoes.some((m) => m._id === mangoId),
  );

  return userType === 'fan_completed' && !hasRequiredBadge && !hasRequiredMango;
};

export const loadMentionedUsers = async (
  channelId: string,
  search: string,
): Promise<IMentionedUser[]> => {
  const query = new URLSearchParams();
  query.append('page', '1');
  query.append('limit', '25');
  query.append('search', search);
  const resp = await CommunityMessagesAPI.getParticipantsInChannel(
    channelId,
    query?.toString(),
  );

  if (resp.status === 200) {
    return resp.data?.result.map((user) => ({
      id: user._id,
      display: user.name,
      profilePicUrl: user.profilePicUrl,
    }));
  }

  return [];
};

export const getChatFileType = (
  media: ChatMediaType,
  file: File,
): ChatMediaType => {
  if (media === 'doc') {
    // return file type based on file
    const [type] = file.type.split('/');

    return (DOC_FILE_TYPES.includes(type) ? 'doc' : type) as ChatMediaType;
  }

  return media;
};
